import {Component, OnInit, Input} from '@angular/core';
import { Model_BERetailDocumentLigne } from '../../be_retail.models';
import { BERetailInventoryInputModel } from '../be-retail-inventory-input.model';
import { Model_WorkflowComponent } from '../../../../../app.models';

@Component({
    selector: 'be-retail-inventory-input-result',
    templateUrl: './be-retail-inventory-input-result.component.html',
    styleUrls: ['./be-retail-inventory-input-result.component.scss']
})
export class BERetailInventoryInputResultComponent implements OnInit {
	@Input() model: BERetailInventoryInputModel;
    @Input() value: Model_BERetailDocumentLigne[];
    component: Model_WorkflowComponent;
    displayedColumns: string[] = ['CODE_BARRE', 'DESIGNATION'/*, 'CODE_FAMILLE'*/, 'FAMILLE'/*, 'COULEUR', 'TAILLE'*/, 'QUANTITE'];

    constructor() {
    }

    ngOnInit() {
        this.component = this.model.additional as Model_WorkflowComponent;
    }

    exportToCsv() {
        if (!!this.value) {
        }
    }
}